import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import { CoursService } from '../../../services/CoursService';

interface Props {
    course: ReqType.Course;
    dateDebut: Date;
    dateFin: Date;
    heureDebut: Date;
    heureFin: Date;
}

interface State {
}

/**
 * Ce composant permet d'afficher une ligne de la liste des listes des cours
 */
export class CourseLine extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <tr key={this.props.course.id}>
                <td>
                    {this.props.course.discipline !== undefined ? this.props.course.discipline.intitule : ''}
                </td>
                <td>
                    {this.props.course.niveau !== undefined ? this.props.course.niveau.intitule : ''}
                </td>
                <td>
                    {this.props.course.details}
                </td>
                <td>
                    {this.props.course.adresse !== undefined ? this.props.course.adresse : ''}
                </td>
                <td>
                    <LoaderButton
                        className="btn btn-danger"
                        onClick={this.createEvents}
                        confirmation={true}
                        modalTitle="Ajout des événements pour l'année"
                        modalBody={
                            'Voulez-vous vraiment ajouter les evenements pour le cours : ' +
                            this.props.course.details
                        }
                    >
                        Ajouter les evenements de l'année
                    </LoaderButton>
                </td>
            </tr>
        );
    }

    createEvents = () => {
        return CoursService.getInstance().generateYearCourse(
            this.props.dateDebut,
            this.props.dateFin,
            this.props.heureDebut,
            this.props.heureFin,
            this.props.course,
        ).then(
            () => alert('Les evenements ont bien étés ajoutés')
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SuperAdminPage/internalComponents/CourseLine.tsx